export default (theme: Object) => ({
  pageFooter: {
    position: 'absolute',
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    color: theme.palette.neutrals.secondaryText,
    paddingTop: '3px',
  },
});
